export const TRY_PATH = "/try";

const TRY_RETURN_KEY = "nobori_try_return_v1";
const TRY_SOURCE_KEY = "nobori_try_source_v1";
const KNOWN_ACCOUNT_KEY = "nobori_known_account_v1";

export const rememberTryReturn = (source: "signup" | "login") => {
  window.sessionStorage.setItem(TRY_RETURN_KEY, TRY_PATH);
  window.sessionStorage.setItem(TRY_SOURCE_KEY, source);
};

export const hasTryLoginReturn = () =>
  window.sessionStorage.getItem(TRY_RETURN_KEY) === TRY_PATH &&
  window.sessionStorage.getItem(TRY_SOURCE_KEY) === "login";

export const consumeTryReturn = () => {
  if (window.sessionStorage.getItem(TRY_RETURN_KEY) !== TRY_PATH) return false;
  window.sessionStorage.removeItem(TRY_RETURN_KEY);
  window.sessionStorage.removeItem(TRY_SOURCE_KEY);
  return true;
};

export const markKnownAccount = () =>
  window.localStorage.setItem(KNOWN_ACCOUNT_KEY, "1");

export const hasKnownAccount = () =>
  window.localStorage.getItem(KNOWN_ACCOUNT_KEY) === "1";
